export default "__VITE_ASSET__ZSeVvMvI__"